var map = {
	"./link.svg": 325,
	"./presentation_1.svg": 646,
	"./presentation_2.svg": 647,
	"./presentation_3.svg": 648,
	"./presentation_4.svg": 649
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 324;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/transplant/icons ^\.\/.*\.svg$
// module id = 324
// module chunks = 1